import Http from './http'

export const getDashboardStats = (params = {}) => Http.get('/admin/dashboard/stats', { params })
